// firebase.js
import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";


// import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAvMZpK-HTuw1V51Ub9sn3ufPob89qPDa8",
  authDomain: "focus-ndt-group.firebaseapp.com",
  projectId: "focus-ndt-group",
  storageBucket: "focus-ndt-group.firebasestorage.app",
  messagingSenderId: "24786582417",
  appId: "1:24786582417:web:7fbce53b11d73df0483830"
};

const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
// const auth = getAuth(app);
const db = getFirestore(app);

const storage = getStorage(app);

export {  db, storage, collection, addDoc, ref, uploadBytes, getDownloadURL, firebaseConfig };
// Export auth and db for use in other parts of the app
// export const db = getFirestore(app);
